import { createStyles, Theme } from '@material-ui/core/styles';
import type { Props } from './Container';

const styles = (theme: Theme) => createStyles({
  root: (props: Props) => ({
    paddingLeft: theme.spacing(props.spacing ?? 4),
    paddingRight: theme.spacing(props.spacing ?? 4),
    height: '100%',
  }),
});

export default styles;
